import {PrismicNextImage} from '@prismicio/next'
import {PrismicRichText} from '@prismicio/react'
import {Icon, IconType} from 'src/common/Icon'
import {PRODUCTS, ADD_ONS, CATEGORIES_ICONS} from 'slices/CustomerStoryContent/v2/constants'
import {ImageField, RichTextField, SelectField} from '@prismicio/client'
import {
  CustomerStoryContentSliceV2PrimaryProductsUsedItem,
  CustomerStoryContentSliceV2PrimaryAddOnsItem,
} from 'prismicio-types'
import {useRouter} from 'next/router'

export const SummarySection = ({
  companyLogo,
  summary,
  products,
  addons,
  category,
  location,
  headcount,
}: {
  companyLogo: ImageField
  summary: RichTextField
  products?: CustomerStoryContentSliceV2PrimaryProductsUsedItem[]
  addons?: CustomerStoryContentSliceV2PrimaryAddOnsItem[]
  category: SelectField<'Ecommerce' | 'Professional Services' | 'Hospitality' | 'Technology'>
  location: string
  headcount: string
}) => {
  const router = useRouter()
  const locale = router.locale?.split('-')[0] as keyof typeof PRODUCTS.label

  return (
    <div className="relative h-full w-full max-lg:order-1">
      <div className="sticky top-[84px] flex flex-col gap-12 bg-beige-100 p-8 max-lg:w-full md:flex-row md:px-10 md:py-12  lg:flex-col lg:rounded-2xl lg:p-8">
        <div className="flex flex-col gap-6 max-lg:w-full">
          <PrismicNextImage field={companyLogo} className="max-h-15" />
          <PrismicRichText
            field={summary}
            components={{
              paragraph: ({children}) => <p className="text-body text-moss-black">{children}</p>,
            }}
          />
          <ul className="text-body flex list-none flex-col gap-3 text-moss-black">
            {category && (
              <li className="flex items-center gap-2">
                <Icon name={CATEGORIES_ICONS[category!]?.icon as IconType} className="h-5 w-5 text-moss-green-300" />
                {CATEGORIES_ICONS[category!]?.label[locale]}
              </li>
            )}
            {location && (
              <li className="flex items-center gap-2">
                <Icon name="map-pin" className="h-5 w-5 text-moss-green-300" />
                {location}
              </li>
            )}
            {headcount && (
              <li className="flex items-center gap-2">
                <Icon name="avatars" className="h-5 w-5 text-moss-green-300" />
                {headcount}
              </li>
            )}
          </ul>
        </div>
        <div className="flex flex-col gap-12 max-lg:w-full">
          <div className="flex flex-col gap-4 max-lg:w-full">
            <p className="text-body-xs-caps text-grey-450">{PRODUCTS.label[locale]}</p>
            <ul className="text-body flex list-none flex-col gap-3">
              {products?.map(({product}, index) => (
                <li key={product! + index} className="text-body flex items-center gap-2 text-moss-black">
                  <Icon name={PRODUCTS[product!]?.icon as IconType} className="h-5 w-5 min-w-5 text-neon-550" />
                  {PRODUCTS[product!]?.label[locale]}
                </li>
              ))}
            </ul>
          </div>
          {addons?.length && addons.length > 0 ? (
            <div className="flex flex-col gap-3">
              <p className="text-body-xs-caps text-grey-450">{ADD_ONS.label[locale]}</p>
              <ul className="text-body flex list-none flex-col gap-3 text-moss-black">
                {addons?.map(({add_on}, index) => (
                  <li key={add_on! + index} className="text-body flex items-center gap-2 text-moss-black">
                    <Icon name={ADD_ONS[add_on!]?.icon as IconType} className="h-5 w-5 min-w-5 text-neon-550" />
                    {add_on}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
